// file path: src\stores\auth.slice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubscriptionPlan } from '../Types/subscription.type';


interface SliceState {
  plan: SubscriptionPlan | null;
}

const initialState: SliceState = {
  plan: null
};

const slice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    setPlan: (state, action: PayloadAction<SubscriptionPlan | null>) => {
      state.plan = action.payload;
    }
  },
});

export const { setPlan } = slice.actions;
const billingReducer = slice.reducer;
export default billingReducer
